import React, { useState } from 'react'
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { LuListMusic } from "react-icons/lu";
import { TbUserScreen } from "react-icons/tb";
import { useLocation, useNavigate } from 'react-router-dom';
import { HiLogout } from 'react-icons/hi';
import { LiaCrossSolid } from "react-icons/lia";
import { getAuth, signOut } from "firebase/auth";
import toast from 'react-hot-toast';
import { Drawer } from 'antd';
import { IoMdClose } from 'react-icons/io'
import { TbMenu } from "react-icons/tb";

const menu = [
  { name: "Dashboard", to: "/dashboard", icon: MdOutlineSpaceDashboard ,size:15,roles:[]},
  { name: "Users", to: "/users", icon: LuListMusic ,size:15,roles:[]},
  { name: "Songs", to: "/songs", icon: TbUserScreen ,size:15,roles:[]},

]




function SideBar({closeMenu}) {


  const {pathname} = useLocation()
  const auth = getAuth();


  const navigate = useNavigate()
  const [drawer_menu,setdrawer_menu] = useState(false)

  function openPage(m){
    navigate(m?.path)
    closeMenu()
  }

  async function handleLogout(){
    await signOut(auth)
    .then(() => {
      toast.success("Logged Out Successfully!")
      navigate("/", { replace: true });
    })
    .catch((error) => {
      console.error(error);
    });
  }

  return (
    <>
      <Drawer onClose={()=>setdrawer_menu(false)} maskClosable={true} open={drawer_menu} closable={false} className='-p-[5%]' width={'80%'}>
          <div className='bg-[#7b026b] h-[100%] '>
          <IoMdClose onClick={()=>setdrawer_menu(false)} size={20} className='absolute top-[5px] left-[-24px] text-white' />
          <div className='flex items-center  px-[5px] py-[6px]'>
          <div className='flex group place-items-center border-[#b040a2]'>
            <LiaCrossSolid size={30} className='text-white' />
            <h6 className='text-[14px] mt-1 ml-2 font-[800] text-white'>IGPH</h6>
          </div>
          </div>

          <h6 className='p-2 bg-slate-100 text-[12px] opacity-60 mt-2 mb-2'>See the menu option list which was created for you for your sales executive portal for app access!.</h6>

           {menu?.map((item)=>(

             

            <>
          
             <div className={`flex  px-1 py-2 pl-2 place-items-center  mb-1  cursor-pointer ${pathname === item?.to ? 'bg-white text-[#1b3f69] opacity-100' : 'text-white opacity-100'}  ${pathname === item?.to && 'opacity-100'} `} onClick={()=>{setdrawer_menu(false);navigate(item.to);}}>
                {item.icon && <item.icon size={16}  /> }
                <span className="mt-0 ml-2 text-[12.5px] font-[600]">
                  {item.name} 
                </span>
              </div> 
             
            </>
           ))}

            <div className={`flex  absolute bottom-2  px-1 py-1 mx-2 text-black  place-items-center  mb-1 cursor-pointer opacity-50 `} onClick={()=>{setdrawer_menu(false);handleLogout()}}>
             {<HiLogout size={16} className='text-white' /> }
             <span className="mt-1 ml-3 uppercase text-[11.5px] text-white font-[600]">
               Log Out 
             </span>
           </div> 
          </div>
         </Drawer>

        <div className='flex min-h-[50px] max-h-[50px] px-2 items-center justify-between w-full md:hidden bg-[#7b026b] w-full'>
          <div className='flex group place-items-center border-[#b040a2]'>
            <LiaCrossSolid size={30} className='text-white' />
            <h6 className='text-[14px] mt-1 ml-2 font-[800] text-white'>IGPH</h6>
          </div>

          <TbMenu onClick={()=>setdrawer_menu(!drawer_menu)} size={25} className='text-white' />
        </div> 
        
        <div className='hidden md:block relative bg-[#7b026b] min-h-screen min-w-[60px] max-w-[60px]'>
        <div className='grid group place-items-center border-b-[0.5px]  border-[#b040a2] py-3'>
          <LiaCrossSolid size={20} className='text-white' />
          <h6 className='text-[10px] mt-1 font-[800] text-white'>IGPH</h6>
        </div>



        {menu?.map((item) => (
        <>
         <React.Fragment key={item?.to}>
            <div key={item?.name}>
              <div className={`grid py-1.5 place-items-center  text-black  mb-1 cursor-pointer ${pathname === item?.to ? 'opacity-100 text-black bg-white ' : 'text-white opacity-70'}  ${pathname === item?.to && 'opacity-100'} `} onClick={()=>{navigate(item.to)}}>
                {item.icon && <item.icon size={item.size}  /> }
                <span className="mt-1 text-[8px] font-[600]">
                  {item.name} 
                </span>
              </div>
            </div>  
          </React.Fragment>   
         
          </>

        ))}

      <div className="grid  bottom-0 py-2 border-white place-items-center opacity-70 hover:opacity-100 text-white  mb-1 cursor-pointer " onClick={handleLogout}>
          <HiLogout size={14}  /> 
          <span className="mt-1 text-[9px] font-[600]">
            {'Log out'}
          </span>
      </div>    

       
        </div>
    </>
  )
}

export default SideBar